import type { ReactNode } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { cn } from '@shared/lib';

interface FieldProps {
  label: string;
  hint?: ReactNode;
  error?: string | null;
  children: ReactNode;
  className?: string;
}

export function Field({ label, hint, error, children, className }: FieldProps) {
  return (
    <label className={cn('flex flex-col gap-1.5', className)}>
      <span className="text-[12px] font-medium uppercase tracking-[0.14em] text-muted">{label}</span>
      {children}
      <AnimatePresence initial={false} mode="wait">
        {error ? (
          <motion.span
            key={error}
            initial={{ opacity: 0, height: 0, marginTop: -6 }}
            animate={{ opacity: 1, height: 'auto', marginTop: 0 }}
            exit={{ opacity: 0, height: 0, marginTop: -6 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            className="block overflow-hidden text-[12px] tracking-[0.02em] text-danger"
          >
            {error}
          </motion.span>
        ) : hint ? (
          <span className="text-[12px] tracking-[0.02em] text-muted">{hint}</span>
        ) : null}
      </AnimatePresence>
    </label>
  );
}
